
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3874_1203)"}},[_c('path',{attrs:{"d":"M23 20.284H1.002c-.55 0-1-.45-1-1V5.286c0-.55.45-1 1-1H23c.55 0 1 .45 1 1v13.998c0 .55-.45 1-1 1zm-20.998-2H22V6.286H2.002v11.998z"}}),_c('path',{attrs:{"d":"M11.971 15.025c-.41 0-.82-.13-1.17-.38l-9.419-7.58a1.002 1.002 0 111.26-1.56l9.38 7.55 9.368-7.55c.43-.35 1.06-.27 1.41.16.34.43.27 1.06-.16 1.41l-9.399 7.52c-.36.29-.81.44-1.25.44l-.02-.01z"}}),_c('path',{attrs:{"d":"M1.002 20.284c-.26 0-.51-.1-.71-.29a.996.996 0 010-1.41l7-6.999a.996.996 0 111.41 1.41l-7 7c-.2.2-.45.29-.71.29h.01zM23 20.284c-.26 0-.51-.1-.71-.29l-6.999-7a.996.996 0 010-1.409.996.996 0 011.41 0l7 7a.996.996 0 01-.71 1.7H23z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3874_1203"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    